// extracted by mini-css-extract-plugin
export default {"menu-item":"navigation-menu-drawer-body_menu-item__7AVoJ"};